import { useTranslation } from 'react-i18next';
import Divider from '@mui/material/Divider';
import { BaseDrawer, BaseDrawerTitle } from '@mgm/common/components/base';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';
import { getIsOpenAllTasklistsNav } from '../../../../store/tasklists/selectors';
import { tasklistsActions } from '../../../../store/tasklists/slice';
import { TasklistsNav } from './TasklistsNav';
import { commonActions } from '../../../../store/common/slice';

const MobileTasklistsNav = () => {
  const isOpenAllTasklistsNav = useAppSelector(getIsOpenAllTasklistsNav);
  const dispatch = useAppDispatch();
  const { t } = useTranslation('tasklists');

  const handleCloseNav = () => {
    dispatch(tasklistsActions.setIsOpenAllTasklistsNav(false));
  };

  const onCloseDrawer = () => {
    dispatch(commonActions.setToggleDrawer(false));
  };

  return (
    <BaseDrawer
      drawerProps={{
        anchor: 'right',
        width: '100%',
        variant: 'persistent',
      }}
      onCloseDrawer={onCloseDrawer}
      open={isOpenAllTasklistsNav}
    >
      <BaseDrawerTitle handleClose={handleCloseNav} title={t('allTasklists')} />
      <Divider sx={{ borderStyle: 'dashed' }} />
      <TasklistsNav />
    </BaseDrawer>
  );
};

export {
  MobileTasklistsNav,
};
